export default __webpack_public_path__ + "static/media/employmentImage1.028717c3.jpg";